import { UnitType } from '@exodus/currency'

import _tokens from './tokens.js'
import { extractUnits } from './utils.js'

const name = 'tronmainnet'
const displayName = 'Tron'
const ticker = 'TRX'
const displayTicker = 'TRX'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#D11E25'
const gradientColors = ['#D11E25', '#A71835']
const gradientCoords = { x1: '11.224%', y1: '-66.682%', x2: '141.81%', y2: '91.487%' }
const chainBadgeColors = gradientColors

const contract = {
  id: 'TRX',
  oldName: null,
}

const units = {
  sun: 0,
  TRX: 6,
}
const currency = UnitType.create(units)

const assetType = 'TRON_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://tronscan.org/#/address/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://tronscan.org/#/transaction/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'TRON is a cryptocurrency dedicated to building the infrastructure for a decentralized Internet.',
  reddit: 'https://www.reddit.com/r/Tronix/',
  twitter: 'https://twitter.com/tronfoundation',
  website: 'https://tron.network/',
  telegram: 'https://t.me/tronnetworkEN',
}

export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  contract,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated
  properTicker: displayTicker, // deprecated
  ticker,
  toString: () => name,
  units,
}

export const tokens = _tokens.map((token) => {
  const units = extractUnits(token)
  return {
    ...token,
    // name,
    // displayName,
    // decimals,
    // ticker,
    // info,
    // primaryColor,
    // gradientColors
    // gradientCoords
    assetType: 'TRON_TOKEN',
    baseAssetName,
    blockExplorer,
    chainBadgeColors: token.chainBadgeColors || token.gradientColors,
    contract: {
      id: token.id,
      oldName: token.oldName,
      address: token.address,
    },
    currency: UnitType.create(units),
    displayNetworkName,
    displayNetworkTicker,
    displayTicker: token.displayTicker || token.ticker,
    info: token.info || {},
    properName: token.displayName, // deprecated
    properTicker: token.displayTicker || token.ticker, // deprecated
    tokenType: token.tokenType,
    toString: () => token.name,
    units,
  }
})

export default [asset, ...tokens]
